import React from 'react';
import TriggerIconButton from 'components/triggers/TriggerIconButton';
import TopicCoverageSelectionView from 'components/triggers/topic-coverage/TopicCoverageSelectionView';
import TopicCoverageSelectionContainer from 'components/triggers/topic-coverage/TopicCoverageSelectionContainer';
import './TopicCoverageSelectionViewPlusButton.styl';
import classnames from 'classnames';

export default class TopicCoverageSelectionViewPlusButton extends React.Component {
  constructor(props) {
    super(props);
    this.toggleSelection = this.toggleSelection.bind(this);
    this.closeSelection = this.closeSelection.bind(this);
    this.saveSelection = this.saveSelection.bind(this);
    this.updateSelection = this.updateSelection.bind(this);
    this.renderDescription = this.renderDescription.bind(this);

    this.state = {
      selectionVisible: false,
      newContext: null,
    };
  }

  toggleSelection() {
    this.props.onSelect(!this.state.selectionVisible);
    const newContext = !this.state.selectionVisible ? {} : null;
    this.setState({
      selectionVisible: !this.state.selectionVisible,
      newContext,
    });
  }

  closeSelection(reason) {
    this.props.onSelect(false);
    this.setState({
      selectionVisible: false,
      newContext: null,
    });
  }

  saveSelection(context) {
    this.props.onSelect(false);
    this.setState({
      selectionVisible: false,
      newContext: null,
    });
    this.props.addItem(context);
  }

  updateSelection(context) {
    this.setState({newContext: context});
  }

  renderDescription() {
    const {selectionVisible, newContext} = this.state;
    const {matchAny} = this.props;

    return newContext == null && (!matchAny || matchAny.size === 0) ? (
      <TriggerIconButton
        className="topic-coverage"
        label="has topic coverage ratio"
        onClick={this.toggleSelection}
        active={selectionVisible}
      />
    ) : (
      <TopicCoverageSelectionView
        {...this.props}
        newContext={newContext}
        defaultText={'has topic coverage ratio'}
        orClick={this.toggleSelection}
      />
    );
  }

  render() {
    const {selectionVisible} = this.state;
    return (
      <div
        className={classnames(
          'topic-coverage-selection-view-plus-button',
          selectionVisible && 'active'
        )}>
        {this.renderDescription()}
        {selectionVisible && (
          <div className="create-rule-popout">
            <TopicCoverageSelectionContainer
              saveSelection={this.saveSelection}
              updateSelection={this.updateSelection}
              saveOnSelect={false}
              closeRequest={this.closeSelection}
            />
          </div>
        )}
      </div>
    );
  }
}
